import React from 'react';
import './Toggle.css';

const Toggle = ({ isOn, handleToggle, onText, offText }) => {
    return (
        <label className="switch">
            <input 
            type="checkbox" 
            checked={isOn}
            onChange={handleToggle}
            />
            <span className="slider round">
            <span className="slider-text">{isOn ? onText : offText}</span>
            </span>
        </label>
        );
    };

export default Toggle;